import { render, staticRenderFns } from "./OrderEntry.vue?vue&type=template&id=024d984f&scoped=true"
import script from "./OrderEntry.vue?vue&type=script&lang=js"
export * from "./OrderEntry.vue?vue&type=script&lang=js"
import style0 from "./OrderEntry.vue?vue&type=style&index=0&id=024d984f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d984f",
  null
  
)

export default component.exports